/** @format */

import {styled} from '@mui/material/styles';
import {Box, Link, Typography} from '@mui/material';

export const Root = styled(Box)(({theme}) => ({
  background: theme.palette.figma_gray_light_1?.main,
  width: '100%',
  height: '114px',
  padding: theme.spacing(4),
  transition: 'background 0.2s',

  '&:hover': {
    background: theme.palette.secondary?.main,
  },
}));

export const StyledLink = styled(Link)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: theme.spacing(4),
}));

export const StyledText = styled(Typography)(({theme}) => ({
  color: theme.palette.figma_gray_dark_1?.main,
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '18px',
}));
